export default "__VITE_ASSET__CKRXHN_i__"